import { FormControl, ValidationErrors } from "@angular/forms";

export function normalTextValidator(control: FormControl): ValidationErrors {
	return !control.value || control.value.trim().length >= 3
	  ? null
	  : { "normal-text": true };
  }
  
  export function normalTextValidatorMessage(err, field) {
	return `"${field.formControl.value}" must be greater than 2 characters`;
  }
  